import { IconSvg } from '@/components/common/icons/IconSvg';
import { Tooltip } from 'antd';
import { FC, ReactNode } from 'react';
import classNames from 'classnames';
import { TooltipPlacement } from 'antd/lib/tooltip';

interface IProps {
  text: ReactNode | string | undefined;
  children?: ReactNode;
  className?: string;
  placement?: TooltipPlacement;
}

export const InfoTooltip: FC<IProps> = ({ text, className, children, placement }) =>
  text ? (
    <Tooltip title={text} placement={placement}>
      {children}{' '}
      <sup className={classNames('opacity-5', className)}>
        <IconSvg icon={'IcoQuestionCircle'} />
      </sup>
    </Tooltip>
  ) : null;
